export default __webpack_public_path__ + "static/media/macos.82d9c85d.svg";